import { AiAgentsPage } from './AiTasksPage';

export default AiAgentsPage;
